module.exports = __webpack_public_path__ + "img/houses.5fbe7269.png";